import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const CoachPatientLoadable = loadable(async () => import('./coach-patient.view'), {
  fallback: <FullPageLoading />,
});
